import { setUsersDashboardFilters, useGetUsersDashboardFilters } from "modules/UsersDashboard/components/UsersDashboardFilters/hooks";
import { USERS_DASHBOARD_STORAGE_KEYS } from "modules/UsersDashboard/storageKeys";
import { setPreference } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";
import type { PAGE_SIZE } from "utils/common";

export const useUsersDashboardTableFilterHandlers = () => {
  const { filters } = useGetUsersDashboardFilters();

  const onPageChange = (data: { activePage: number }) => setUsersDashboardFilters({ ...filters, page: data.activePage });

  const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: filters.page - 1, pageSize: filters.page_size }) : updater;
    onPageChange({ activePage: newState.pageIndex + 1 });
  };

  const handlePageSizeChange = (value: PAGE_SIZE) => {
    setPreference(USERS_DASHBOARD_STORAGE_KEYS.PageSizePreference, value);
    setUsersDashboardFilters({ ...filters, page_size: value, page: 1 });
  };

  return { handlePageSizeChange, handlePaginationChange };
};
